import ErrorCode from '../components/common/ErrorCode'

const NotFound = () => <ErrorCode errors="Not Found" code="404" />

export default NotFound
